import Hero from '../components/Hero/Hero';
import Outcomes from '../components/Outcomes/Outcomes';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import Features from '../components/Features/Features';
import ShowcaseMockups from '../components/ShowcaseMockups/ShowcaseMockups';
import FAQ from '../components/FAQ/FAQ';
import CTASection from '../components/CTASection/CTASection';
import { usePageTitle } from '../hooks/usePageTitle';
import { useScrollToHash } from '../hooks/useScrollToHash';

function HomePage() {
  usePageTitle();
  useScrollToHash();

  return (
    <>
      <Hero />
      <Outcomes />
      <HowItWorks />
      <Features />
      <ShowcaseMockups />
      <FAQ />
      <CTASection />
    </>
  );
}

export default HomePage;
